import { useField } from 'formik';
import { useState } from 'react';

import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import { capitalize } from '../../utils/utils';

import {
  FieldErrorInfo,
  IInputField,
  Input,
  InputContainer,
  InputLabel,
  InputWrapper,
} from './FormField';

export const HideableTextFormField: React.FC<IInputField> = ({
  label,
  lpiSrc,
  rpiSrc,
  className,
  // apiKey,
  ...props
}) => {
  const [field, meta] = useField(props);
  const [showKey, setShowKey] = useState(false);

  const handleToggle = () => {
    setShowKey(!showKey);
  };

  return (
    <>
      <InputWrapper className={className}>
        <InputLabel htmlFor={props.name || props.id}>{label}</InputLabel>
        <InputContainer>
          <Input {...field} {...props} type={showKey ? 'text' : 'password'} />
          <VisibilityToggleIconsArea>
            {showKey ? (
              <EyeOutlined onClick={handleToggle} />
            ) : (
              <EyeInvisibleOutlined onClick={handleToggle} />
            )}
          </VisibilityToggleIconsArea>
        </InputContainer>
        {meta.touched && meta.error ? (
          <FieldErrorInfo>{capitalize(meta.error)}</FieldErrorInfo>
        ) : null}
      </InputWrapper>
    </>
  );
};

const VisibilityToggleIconsArea = styled.div`
  display: flex;
  margin-right: 1rem;
  margin-left: auto;

  & > * > svg {
    color: #867c79;
  }
`;
